(function () {
  function init() {
    var triggers = document.querySelectorAll('.WBP_VismaVideoTrigger');
    var modal = document.getElementById('WBP_VismaVideoModal');
    var backdrop = modal && modal.querySelector('[data-wbp-visma-close]');
    var iframe = document.getElementById('WBP_VismaVideoIframe');
    var activeTrigger = null;

    if (!triggers.length || !modal || !iframe) return;

    function getVideoSrc(trigger) {
      return (
        trigger.getAttribute('data-video-src') ||
        'https://www.youtube.com/embed/61IpC1v7A1o?enablejsapi=1&rel=0&autoplay=1'
      );
    }

    function openModal(trigger) {
      activeTrigger = trigger;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      iframe.src = getVideoSrc(trigger);
      if (backdrop) backdrop.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      iframe.removeAttribute('src');
      if (activeTrigger) activeTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(trigger);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(trigger);
        }
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closeModal();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
